import styled from "styled-components";
import colors from "../../assets/colors";

export const ModalContainer = styled.div`
  position: absolute;
  width: 400;
  background-color: ${colors.palette.white};
  position: absolute;
  top: 25%;
  left: 25%;
  width: 50%;
  padding: 50px;
`;

export const Container = styled.div`
  display: flex;
  flex: 8;
  flex-direction: column;
  height: 90%;
  background-color: ${colors.palette.primary};
  @media (orientation: portrait) {
    justify-content: center;
  }
`;

export const FormLogin = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  flex: 0.5;
  padding: 0 50px;
  background-color: ${colors.palette.primary};
  @media (orientation: portrait) {
    flex: 1;
  }
`;

export const Title = styled.text`
  font-family: GilroyBold;
  color: ${colors.palette.secondary};
  font-size: 40px;
  align-self: start;
`;

export const Label = styled.label`
  cursor: pointer;
  font-size: 14px;
  font-family: GilroyMedium;
  color: ${colors.palette.secondary};
  align-self: start;
  margin: 0px;
`;

export const ContainerButton = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  &:hover {
    color: ${colors.palette.white};
  }
`;
export const GlassBtn = styled.button`
  cursor: pointer;
  display: flex;
  justify-content: center;
  border-radius: 50px;
  outline: none;
  font-size: 14px;
  font-family: GilroyMedium;
  align-items: center;
  color: ${colors.palette.primary};
  padding: 10px;
  height: ${(props) => (props.height ? props.height + "px" : "35px")};
  border: ${(props) => (props.empty ? "none" : `1.5px solid ${colors.palette.primary}`)};
  background: ${colors.palette.secondary};
`;

export const Input = styled.input`
  color: white;
  border: none;
  border-radius: 0;
  padding: 6px;
  font-family: GilroyMedium;
  font-size: 18px;
  font-weight: lighter;
  border-bottom: 1.5px solid ${colors.palette.secondary};
  outline: none;
  background: transparent;
  height: 25px;
  margin: 0px auto;
  ::placeholder {
    color: ${colors.palette.lightGray};
    opacity: 1;
  }

  :-ms-input-placeholder {
    color: ${colors.palette.lightGray};
  }

  ::-ms-input-placeholder {
    color: ${colors.palette.lightGray};
  }
`;
export const ErrorMessage = styled.p`
  color: white;
  font-family: GilroyMedium;
  font-size: 12px;
  font-weight: lighter;
  margin: 0;
`;
